import Service from "../Service";
const resource = "paymentcategorydetail/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  save(prd, requestID) {
    return Service.post(resource + "save", prd, {
      params: { requestID: requestID },
    });
  },
  saveMassive(prd, requestID) {
    return Service.post(resource + "saveMassive", prd, {
      params: { requestID: requestID },
    });
  },
};
